module.exports = __webpack_public_path__ + "media/images/emblems/Greppen_LU-41a6cafddf7bac9c8cb657f5dd3c0210.png";